define('modules/error_pages',['modules/noths.recommendations'], function (Recommendations) {
  function sendRecommendationData() {
    if (Recommendations.isEnabled()) {
      return Recommendations.setUp().then(function () {
        Recommendations.sendErrorData();
      });
    } else {
      Recommendations.hide();
    }
  }

  return {
    sendRecommendationData: sendRecommendationData,
  };
});

